import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { Bert } from 'meteor/themeteorchef:bert';

import {
  getPublicDataId,
  isShared,
  getId,
  isSharedPrivate
} from '../../../api/Layers/layer-operations';

import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import ThematicLayerContainer from '../../containers/ThematicLayerContainer';

import ShareColumn from '../../atoms/ShareColumn';

const toggleShared = async (layerId, isSharedData) => {
  try {
    await methodPromise('layers.toggleSharedLayerData', layerId, !isSharedData);
    if (!isShared) {
      Bert.alert('Link Created', 'success');
    } else {
      Bert.alert('No longer Shared', 'info');
    }
  } catch (error) {
    handleErrorInClient(error);
  }
};

const toggleSharedPrivate = async (layerId, isSharedData) => {
  try {
    await methodPromise('layers.toggleSharedPrivateLayerData', layerId, !isSharedData);
    if (!isSharedPrivate) {
      Bert.alert('Link Created', 'success');
    } else {
      Bert.alert('No longer Shared', 'info');
    }
  } catch (error) {
    handleErrorInClient(error);
  }
};

const ViewThematicLayerTable = props => {
  const { layer, isAdmin, isPremium, isBasic } = props;
  const role = isAdmin || isPremium || isBasic;
  return (
    <Row noGutters>
      {role && (
        <ShareColumn
          toggleShared={() => toggleShared(getId(layer), isShared(layer))}
          isShared={isShared(layer)}
          sharedPath={`shared/data/${getPublicDataId(layer)}`}
          toggleSharedPrivate={() => toggleSharedPrivate(getId(layer), isSharedPrivate(layer))}
          isSharedPrivate={isSharedPrivate(layer)}
          sharedPathPrivate={`sharedPrivate/data/${getPublicDataId(layer)}`}
        />
      )}

      <Col xs={12} sm={8} md={9}>
        <ThematicLayerContainer layer={layer} />
      </Col>
    </Row>
  );
};

ViewThematicLayerTable.propTypes = {
  layer: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  isPremium: PropTypes.bool.isRequired,
  isBasic: PropTypes.bool.isRequired
};

export default ViewThematicLayerTable;
